import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@chapche/ui';
import { ListViewMode } from './listViewStorage';
import { StrokeListIcon } from '../../appearence/icons/stroke_list_icon';
import { GridViewIcon } from '../../appearence/icons/grid_view_icon';

type ListViewSwitcherProps = {
    mode: ListViewMode;
    onChange: (mode: ListViewMode) => void;
    disabled?: boolean;
};

const ListViewSwitcher = ({ mode, onChange, disabled = false }: ListViewSwitcherProps) => {
    const { i18n } = useTranslation();

    return (
        <div
            className="inline-flex shrink-0 overflow-hidden rounded-sm border border-solid border-light-grey bg-white"
            role="group"
            aria-label={i18n.t('app.page.listView.ariaLabel')}
            title={disabled ? i18n.t('app.page.listView.tableUnavailable') : undefined}
        >
            <Button
                type="button"
                size="small"
                variant={mode === 'tile' ? 'default' : 'ghost'}
                className="rounded-none"
                aria-pressed={mode === 'tile'}
                disabled={disabled}
                onClick={() => onChange('tile')}
            >
                <GridViewIcon nameOfClass="list-view-switcher__icon" />
                <span className="ml-8 first-letter:normal-case">{i18n.t('app.page.listView.tile')}</span>
            </Button>
            <Button
                type="button"
                size="small"
                variant={mode === 'table' ? 'default' : 'ghost'}
                className="rounded-none"
                aria-pressed={mode === 'table'}
                disabled={disabled}
                onClick={() => onChange('table')}
            >
                <StrokeListIcon nameOfClass="list-view-switcher__icon" />
                <span className="ml-8 first-letter:normal-case">{i18n.t('app.page.listView.table')}</span>
            </Button>
        </div>
    );
};

export default ListViewSwitcher;
